import { DotLottiePlayer } from '@dotlottie/react-player';
import mascotAnimationMatrixSrc from '../assets/mascot-animation-matrix.lottie';
type Props = {
  autoplay?: boolean;
};
export const MascotAnimationMatrix = ({
  autoplay = true
}: Props) => <DotLottiePlayer src={mascotAnimationMatrixSrc} loop autoplay={autoplay} data-sentry-element="DotLottiePlayer" data-sentry-component="MascotAnimationMatrix" data-sentry-source-file="MascotAnimationMatrix.tsx" />;